import StringFormat from "string-format";
import apisauce from "apisauce";
import QueryString from "qs";
import { ApiConstant, AppConstant, FormatConstant } from "const";
import { LocalApiCallService } from "services/local.service";
import { convertString2JSON } from "utils";

export function* executeQueueLogout() {
  try {
    if (navigator.onLine) {
      // Get all active branches
      const logoutApiCalls = yield LocalApiCallService.find({
        task: AppConstant.API_CALL_TASK.logout,
      });

      if (Array.isArray(logoutApiCalls) && logoutApiCalls.length > 0) {
        for (let index = 0; index < logoutApiCalls.length; index++) {
          const apiCall = logoutApiCalls[index];
          const { id, content, retry } = apiCall;
          const contentObj = content ? convertString2JSON(content, {}) : {};
          const { domain, params, token } = contentObj;
          if (Boolean(domain && params && token)) yield handleCallLogoutDevice(id, domain, params, token, retry);
          else console.error("Invalid data: ", domain, params, token);
        }
      } else {
        return;
      }
    }
  } catch (error) {
    console.error(error);
  }
  return;
}

const handleCallLogoutDevice = async (id, domain, params, token, retry) => {
  if (retry > 10) {
    await LocalApiCallService.delete(id);
    return;
  } else {
    const isServerOnline = await checkServerOnline(domain);
    if (isServerOnline) {
      const baseUrl = StringFormat(FormatConstant.FM_BASE_URL, domain);
      const logoutResponse = await apisauce
        .create({
          baseURL: baseUrl,
          headers: {
            ...ApiConstant.HEADER_DEFAULT,
            Authorization: `Bearer ${token}`,
          },
          timeout: ApiConstant.TIMEOUT,
        })
        .post(ApiConstant.POST_UPDATE_DEVICE, QueryString.stringify(params));

      if ([ApiConstant.STT_OK, ApiConstant.STT_UNAUTHORIZED].includes(logoutResponse.status)) {
        await LocalApiCallService.delete(id);
        return;
      } else {
        await LocalApiCallService.update({ retry }, { id });
        setTimeout(() => {
          handleCallLogoutDevice(id, domain, params, token, retry + 1);
        }, AppConstant.ONE_MINUTE);
      }
    }
  }
};

const checkServerOnline = async domain => {
  if (!navigator.onLine) return false;

  const baseUrl = StringFormat(FormatConstant.FM_BASE_URL, domain);

  const response = await apisauce
    .create({
      baseURL: baseUrl,
      headers: ApiConstant.HEADER_DEFAULT,
      timeout: ApiConstant.TIMEOUT,
    })
    .get(ApiConstant.GET_SERVER_TIME);

  return Boolean(response.status === ApiConstant.STT_OK && navigator.onLine);
};
